import styled, { css } from 'styled-components';

import {
  borderRadius8,
  boxShadowBlack8,
  standardFocusState,
} from 'approot/shared/styles/borders.style';
import { mediaUp, rem } from 'approot/shared/style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import {
  grey1,
  grey10,
  grey5,
  purple1,
  purple7,
} from 'approot/shared/styles/colours.style';
import { fontSize16, fontSize18 } from 'approot/shared/styles/typography.style';
import { spacing12, spacing16 } from 'approot/shared/styles/spacing.style';
import { ActivityPosition, POSITION_RIGHT } from 'global/constants';

export const RiveComponentTrigger = styled.button`
  background-color: transparent;
  border: none;
  border-radius: ${rem(borderRadius8)};
  padding: 0;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 0;
  overflow: hidden;

  ${standardFocusState}

  &:focus {
    height: auto;
    bottom: 0;
    overflow: auto;
  }
`;

type RiveButtonsProps = {
  $position?: ActivityPosition | null;
};

export const RiveButtons = styled.div<RiveButtonsProps>`
  gap: ${rem(spacing12)};
  position: absolute;

  ${({ $position }) =>
    $position === POSITION_RIGHT
      ? css`
          display: flex;
          flex-direction: column;
          right: ${rem(spacing16)};
          transform: translate(0, -50%);
          top: 50%;
        `
      : css`
          ${flexCentreAlignCss}
          left: 0;
          right: 0;
          bottom: ${rem(spacing16)};
        `}
`;

export const RiveButton = styled.button`
  ${boxShadowBlack8}
  ${flexCentreAlignCss}
  ${standardFocusState}

  background-color: ${grey1};
  border: 1px solid ${grey5};
  border-radius: ${rem(40)};
  font-size: ${rem(fontSize16)};
  color: ${grey10};
  min-height: ${rem(32)};
  padding: 0 ${rem(spacing12)};

  ${mediaUp.md`
    font-size: ${rem(fontSize18)};
    min-height: ${rem(40)};
    padding: 0 ${rem(spacing16)};
  `}

  &:hover {
    background-color: ${purple1};
    border-color: ${purple7};
    color: ${purple7};
    cursor: pointer;
  }

  &:active,
  &:active:focus {
    box-shadow:
      0px 4px 16px rgba(0, 0, 0, 0.08),
      inset 0px 4px 8px rgba(0, 0, 0, 0.24);
    background-image: none;
  }
`;
